export const da = {
    yourOrder: 'Din Ordre',
    welcome: 'Velkommen!',
    subtotal: 'Subtotal (inklusiv moms):',
    discount: 'Rabat:',
    tax: 'Moms:',
    remainingPayment: 'At betale:',
    refundDue: 'Tilbagebetaling:',
    change: 'Byttepenge:',
    login: 'Log ind med din Microsoft-konto',
    invalidTenant: 'Ugyldig tenant',
    invalidTenantMessage: 'Vi kunne ikke bekræfte denne tenant. Tjek linket, eller kontakt support.',
    missingTenant: 'Tenant-parameter mangler',
    missingTenantMessage: 'Åbn appen med en URL som:',
    backToSetup: 'Tilbage til opsætning',
    backToSetupQuestion: 'Vil du tilbage til opsætningen?',
    resetApp: 'Nulstil displayet',
    resetAppQuestion: 'Slet alle gemte indstillinger og login-data på denne enhed?',
    cancel: 'Annuller',
    confirm: 'Bekræft',
    selectEnvironment: 'Vælg et miljø',
    selectCompany: 'Vælg et regnskab',
    selectPosUnit: 'Vælg en kasseenhed',
    environment: 'Miljø:',
    company: 'Regnskab:',
    posUnit: 'Kasseenhed:',
    changeEnvironment: 'Skift miljø',
    changeCompany: 'Skift regnskab',
    changePosUnit: 'Skift kasseenhed',
    lineOrder: 'Linjerækkefølge:',
    newestFirst: 'Nyeste først',
    oldestFirst: 'Ældste først',
    setInUrl: (setting) => `Angivet i URL'en (${setting}) — ret det dér.`,
    standbyAfterSale: 'Standby efter salg:',
    seconds: 'sekunder',
    displayUrl: 'Display-URL:',
    copyUrl: 'Kopiér URL',
    copied: 'Kopieret',
    copyFailed: 'Kopiering mislykkedes',
    autoConfirmPaused: 'Displayet starter ikke automatisk, før du trykker Bekræft.',
    switchAccount: 'Skift Microsoft-konto',
    clear: 'Ryd',
    urlSettingsTitle: "Hvad kan sættes i URL'en",
    urlTenant: 'Microsoft tenant-ID (påkrævet)',
    urlPreselect: 'Forudvælg opsætningstrinnene',
    urlAutoConfirm: 'Spring denne side over ved start',
    urlLineOrder: 'newestFirst eller oldestFirst',
    urlStandbyDelay: 'Sekunder et afsluttet salg bliver på skærmen, standard 180',
    urlColors: '6-cifret hex-farve uden #, f.eks. 75153b',
    urlLang: 'da dansk, de tysk, no norsk, ellers engelsk',
    urlCrane: 'On-premise-tilstand',
    urlOnPremiseLogin: 'On-premise-login, sammen med environment og company',
    urlReset: 'Alene i URL\'en: sletter gemte indstillinger og login-data på denne enhed',
    holdToReturn: 'I appen: hold et vilkårligt sted på skærmen i 5 sekunder for at komme tilbage til opsætningen.',
    missingTenantInUrl: "Tenant mangler i URL'en. Åbn appen med ?tenant=<MS tenant id>.",
    fetchEnvironmentsFailed: 'Kunne ikke hente miljøer på denne tenant, enten på grund af en netværksfejl eller manglende rettigheder.',
    fetchCompaniesFailed: 'Kunne ikke hente regnskaber på denne tenant, enten på grund af en netværksfejl eller manglende rettigheder.',
    fetchPosUnitsFailed: 'Kunne ikke hente kasseenheder på denne tenant, enten på grund af en netværksfejl eller manglende rettigheder.',
    autoStartMissing: (settings) => `Autostart stoppet: URL'en mangler ${settings}.`,
    autoStartNotFound: (setting, urlValue) => `Autostart stoppet: ${setting} '${urlValue}' fra URL'en blev ikke fundet.`,
};
